import React, { useEffect, useState } from 'react';
import { BedPlan } from '../types';
import { fetchGardens } from '../services/api';
import './BedHistory.css';

type Props = {
  onLoad: (plan: BedPlan) => void;
  onDelete: (gardenId: string) => void;
  currentPlanId: string | null;
  title?: string;
  /** When set, only show saved seasons for this bed name (excluding the current plan). */
  filterName?: string;
};

export default function BedHistory({ onLoad, onDelete, currentPlanId, title = '📚 Past seasons', filterName }: Props) {
  const [plans, setPlans] = useState<BedPlan[]>([]);
  const [confirmId, setConfirmId] = useState<string | null>(null);

  useEffect(() => {
    fetchGardens().then(setPlans);
  }, [currentPlanId]);

  const confirmDelete = (gardenId: string) => {
    onDelete(gardenId);
    setPlans(prev => prev.filter(p => p.gardenId !== gardenId));
    setConfirmId(null);
  };

  const visible = filterName == null
    ? plans
    : plans.filter(p => p.name === filterName && p.gardenId !== currentPlanId);

  if (visible.length === 0) return null;

  return (
    <section className="history">
      <h2 className="history__title">{title}</h2>
      <ul className="history__list">
        {visible
          .slice()
          .sort((a, b) => new Date(b.savedAt).getTime() - new Date(a.savedAt).getTime())
          .map(plan => (
            <li key={plan.gardenId} className={`history__item${plan.gardenId === currentPlanId ? ' history__item--active' : ''}`}>
              <div className="history__info">
                <span className="history__name">{plan.name}</span>
                <span className="history__season">{plan.season} · {plan.widthFt}×{plan.heightFt}ft</span>
                <span className="history__date">{new Date(plan.savedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
              </div>
              {confirmId === plan.gardenId ? (
                <div className="history__confirm" role="group" aria-label={`Delete ${plan.name}?`}>
                  <span className="history__confirm-text">Delete?</span>
                  <button className="history__btn history__btn--danger" onClick={() => confirmDelete(plan.gardenId)}>
                    Yes
                  </button>
                  <button className="history__btn history__btn--ghost" onClick={() => setConfirmId(null)}>
                    No
                  </button>
                </div>
              ) : (
                <>
                  <button className="history__btn" onClick={() => onLoad(plan)}>
                    View
                  </button>
                  <button
                    className="history__btn history__btn--delete"
                    onClick={() => setConfirmId(plan.gardenId)}
                    aria-label={`Delete ${plan.name}`}
                  >
                    ✕
                  </button>
                </>
              )}
            </li>
          ))}
      </ul>
    </section>
  );
}
